import { render, staticRenderFns } from "./Outbox.vue?vue&type=template&id=e77ef6d2&"
import script from "./Outbox.vue?vue&type=script&lang=js&"
export * from "./Outbox.vue?vue&type=script&lang=js&"
import style0 from "./Outbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports